import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getRemoteConfig } from "firebase/remote-config";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCxtLXwphafQEqy6iLwhiBndA-UNXdRYLg",
  authDomain: "jussbot-1836a.firebaseapp.com",
  projectId: "jussbot-1836a",
  storageBucket: "jussbot-1836a.firebasestorage.app",
  messagingSenderId: "595967820894",
  appId: "1:595967820894:web:1d4de4c7cf203b812ce0cf",
  measurementId: "G-KM6DC96DHT",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const firestore = getFirestore(app);
export const analytics = getAnalytics(app);
export const remoteConfig = getRemoteConfig(app);
// Samme region som Cloud Functions v2
export const functions = getFunctions(app, "us-central1");